import React, { useState, useCallback } from 'react';

const InterfaceContext = React.createContext();

const InterfaceContextProvider = ({ children, handleKeyDown }) => {
  const [ isKeyboardVisible, setIsKeyboardVisible ] = useState(false);
  const toggleKeyboard = useCallback(() =>
    setIsKeyboardVisible(!isKeyboardVisible),
    [setIsKeyboardVisible, isKeyboardVisible]
  );

  return (
    <InterfaceContext.Provider value={{
      handleKeyDown,
      toggleKeyboard,
      setIsKeyboardVisible,
      isKeyboardVisible
    }}>
      {children}
    </InterfaceContext.Provider>
  )
}

export { InterfaceContextProvider, InterfaceContext };
